import ExpandedItem from './ExpandedItem';

export default ExpandedItem;
